import { Component, OnInit, HostBinding, Renderer2, ViewChild, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppServiceService } from 'src/app/api/app-service.service';
import { ModalController, PopoverController } from '@ionic/angular';
import { TableReservationPage } from "../modals/table-reservation/table-reservation.page";
import { environment } from '../../../environments/environment';
import { Subscription, interval } from 'rxjs';
import { CallNumber } from '@ionic-native/call-number/ngx';
import { SelectOrderTypePage } from '../modals/select-order-type/select-order-type.page';
import { TourPage } from '../modals/tour/tour.page';
import { InAppBrowser, InAppBrowserOptions } from "@ionic-native/in-app-browser/ngx";
import { WelcomePackageOfferPage } from '../modals/welcome-package-offer/welcome-package-offer.page';
import { InputSelectModalPointsComponent } from 'src/app/component/input-select-modal-points/input-select-modal-points.component';
import { InputSelectModalComponent } from 'src/app/component/input-select-modal/input-select-modal.component';

@Component({
  selector: 'app-home-single',
  templateUrl: './home-single.page.html',
  styleUrls: ['./home-single.page.scss'],
})
export class HomeSinglePage implements OnInit {

  public slideOpts: any;
  public slideOpts2: any;
  public mostPopularDishes: any[] = [];

  public baseURL = environment.BASE_URL;

  //timeCount
  private subscription: Subscription;
  public dDay: any;
  public milliSecondsInASecond = 1000;
  public hoursInADay = 24;
  public minutesInAnHour = 60;
  public SecondsInAMinute = 60;
  public timeDifference;
  public secondsToDday;
  public minutesToDday;
  public hoursToDday;
  public daysToDday;
  public isCounter: boolean = false;
  public isFirst: boolean = true;
  public is_point_enable: boolean = false;
  public is_point_recharge_enable: boolean = false;

  public firstHalfs;
  public secondHalfs;

  public customContainer: HTMLElement = null;

  // order now button animated arrow colors
  @HostBinding('style.--color-active')
  public colorActive: string = '#ffffff';
  @HostBinding('style.--color-inactive')
  public colorInactive: string = '#c1091b';
  @HostBinding('style.--favourite-restaurant-icon')
  public favRestaurantIcon: string = '#ffbc00';

  public currentPopover = null;

  private tourOpened: boolean = false;

  // social links
  public facebookLink: string = '';
  public facebookUserID: string = '';
  public instagramLink: string = '';
  public instagramUserID: string = '';
  public pinterestLink: string = '';
  public pinterestUserID: string = '';
  public tiktokLink: string = '';
  public tiktokUserID: string = '';
  public youtubeLink: string = '';
  public youtubeUserID: string = '';

  public displaySocialButtons: boolean = false;
  public points: string = '0';

  public invitedUserEmail: string = '';

  public successPayment: any = null;
  @ViewChild('rechargeSuccess') rechargeSuccess: TemplateRef<any>;

  public logingWhileRequestingPostalCode: boolean = false;
  public logingWhileRequestingNewPostalCode: boolean = false;

  // It was calling getDiscounts() function continuesly in html,
  // to avoid that issue moved discount list into this array object
  // this object will refresh once the page initialized and each time settings are getting loaded
  // patched by Pumayk26 pushed from Ashan's Mac
  public discountsList:any[] = [];

  constructor(public appService: AppServiceService, public modalController: ModalController, private router: Router, private route: ActivatedRoute,
    private callNumber: CallNumber, public popoverCtrl: PopoverController, private render: Renderer2, public inab: InAppBrowser) { }

  ngOnInit() {
    this.baseURL = environment.BASE_URL;

    // refresh discounts list
    this.discountsList = this.getDiscounts();

    // by default custome container has height auto, but while loading it shows empty space,
    // to avoid that set height 100% till data load.
    this.customContainer = document.getElementById('custom-container');
    if (this.customContainer) {
      this.customContainer.style.height = '100%';
    }

    let doNotShowWelcomePackage = false;
    // open welcome package order process if user came from welcome package direct url
    this.route.queryParams.subscribe((params) => {
      if (params && params.welcome_package && params.welcome_package === 'true') {
        this.appService.welcomePackageOnTheWay = true;
        this.appService.welcomePackageOnTheWayFromDirectLink = true;
        // this.orderNow();
      }

      if (params && params.killCode === 'true') {
        doNotShowWelcomePackage = true;
      }

      // when user try to request new postal code or vote for existing awaiting requests postal code
      // once logged in user will be redirected to the home page with below parameters
      this.logingWhileRequestingPostalCode = false;
      if (params && params.requestPostalCode === 'true') {
        this.logingWhileRequestingPostalCode = true;
      }

      this.logingWhileRequestingNewPostalCode = false;
      if (params && params.requestNewPostalCode === 'true') {
        this.logingWhileRequestingNewPostalCode = true;
      }
    });

    // fetch app settings once settings data loaded successfully
    this.appService.triggerSettingsLoadedSuccssfulyCallback().subscribe(async (response) => {
      /**Related with customer csv import feature*/
      if (this.appService.appObject.invitedUserEmailRaw) {
        this.invitedUserEmail = this.appService.appObject.invitedUserEmailRaw;
      }

      if (this.appService.appObject.settings.main_restaurant.openDetails.current_status === "closed" && this.appService.appObject.settings.main_restaurant.openDetails.is_current_status === "true") {
        this.subscription = interval(1000).subscribe(x => { this.getTimeDifference(this.appService.appObject.settings.main_restaurant.openDetails.count_down_date); });
        this.isCounter = true;
      }
      this.isFirst = false;
      this.fetchHighlightList();
      this.fetchBranchesList();
      // once settings data loaded, set custom container height to auto
      if (this.customContainer) {
        setTimeout(() => {
          this.customContainer.style.height = '';
        }, 2000);
      }

      // check for avilability of welcome order package, and display popup
      if (!this.appService.appObject.orderObject.claimWelcomePackage && !this.appService.appObject.doNotShowWelcomePackage && this.appService.appObject.settings.main_restaurant
        && this.appService.appObject.settings.main_restaurant.welcome_package_configurations && this.appService.appObject.settings.main_restaurant.welcome_package_configurations.status) {

        // if the user logged in, then check his eligibility of welcome package order
        if (this.appService.appObject.isAuthed) {
          // This line move to top
          // await this.appService.getUserDetails({customer_id:this.appService.appObject.userId});
          if (this.appService.appObject.loggedInUserData && this.appService.appObject.loggedInUserData.eligible_for_welcome_order) {
            // check whether user is invited, if invited we must open password reset ui instead of welcome package
            if (!this.invitedUserEmail && !this.appService.welcomePackageOnTheWayFromDirectLink && !doNotShowWelcomePackage) this.openWelcomePackagePopUp();
            // if welcomePackageOnTheWayFromDirectLink is true, then open order process to checkout welcome package directly
            else if (this.appService.welcomePackageOnTheWayFromDirectLink) this.orderNow();
          }
        } else {
          // if this is a guest user, then let him put into cart and check eligibility before checkout
          // check whether user is invited, if invited we must open password reset ui instead of welcome package
          if (!this.invitedUserEmail && !this.appService.welcomePackageOnTheWayFromDirectLink && !doNotShowWelcomePackage) this.openWelcomePackagePopUp();
          // if welcomePackageOnTheWayFromDirectLink is true, then open order process to checkout welcome package directly
          else if (this.appService.welcomePackageOnTheWayFromDirectLink) this.orderNow();
        }

      }

      this.checkSocialMediaLinks();

      // get points system configurations
      this.checkPointSystemConfigurations();

      // if invited user email received, then open password reset ui
      if (this.invitedUserEmail) {
        let response = await this.appService.checkIsUserImportedAndInvited(atob(this.invitedUserEmail));
        if (response && response.status) this.router.navigate(['forgot-password'], { queryParams: { ue: this.invitedUserEmail }, replaceUrl: true });
        this.invitedUserEmail = '';
      }

      if (this.logingWhileRequestingPostalCode) {
        this.appService.appObject.settings.app_configuration.has_multiple_restaurants ? this.orderNow(null, false) : this.orderNowSingleRestaurant();
        this.router.navigate(['home'], { replaceUrl: true });
      }else if(this.logingWhileRequestingNewPostalCode){
        this.appService.appObject.settings.app_configuration.has_multiple_restaurants ? this.orderNow(null, false) : this.orderNowSingleRestaurant();
        this.router.navigate(['home'], { replaceUrl: true });
      }

      // refresh discount list each time settings getting loaded
      this.discountsList = this.getDiscounts();
    });

    this.slideOpts = {
      initialSlide: 1,
      speed: 400,
      autoplay: true,
      slidesPerView: 1,
    };


    this.slideOpts2 = {
      initialSlide: 2,
      speed: 400,
      autoplay: true,
      slidesPerView: 2,
    };
    document.onvisibilitychange = (e) => {
      if (!(document.visibilityState === 'hidden')) {
        this.appService.getSettings();
      }
    };
  }

  /**
   * Check social media links
   * Before this code was in settingscallback success, when ion view enter this code didn't firedup so moved to a function and call in ionViewDidEnter event too
   */
  checkSocialMediaLinks() {
    if (this.appService.appObject.settings.main_restaurant && this.appService.appObject.settings.main_restaurant.show_social_buttons === 'true') {
      this.displaySocialButtons = true;
      if (this.appService.appObject.settings.main_restaurant.facebook_link) {
        this.facebookLink = this.appService.appObject.settings.main_restaurant.facebook_link;
        let splitted = this.facebookLink.split('/');
        this.facebookUserID = splitted[3] ? splitted[3] : '';
      }

      if (this.appService.appObject.settings.main_restaurant.instagram_link) {
        this.instagramLink = this.appService.appObject.settings.main_restaurant.instagram_link;
        let splitted = this.instagramLink.split('/');
        this.instagramUserID = splitted[3] ? splitted[3] : '';
      }

      if (this.appService.appObject.settings.main_restaurant.pinterest_link) {
        this.pinterestLink = this.appService.appObject.settings.main_restaurant.pinterest_link;
        let splitted = this.pinterestLink.split('/');
        this.pinterestUserID = splitted[3] ? splitted[3] : '';
      }

      if (this.appService.appObject.settings.main_restaurant.youtube_link) {
        this.youtubeLink = this.appService.appObject.settings.main_restaurant.youtube_link;
        let splitted = this.youtubeLink.split('/');
        this.youtubeUserID = splitted[3] ? splitted[3] : '';
        if (this.youtubeUserID[0] !== '@') this.youtubeUserID = ('@' + this.youtubeUserID);
      }

      if (this.appService.appObject.settings.main_restaurant.tiktok_link) {
        this.tiktokLink = this.appService.appObject.settings.main_restaurant.tiktok_link;
        let splitted = this.tiktokLink.split('/');

        // sometimes the link contains query parameters
        // to avoit those values split again
        let splitAgain = splitted[3].split('?');

        this.tiktokUserID = splitAgain[0] ? splitAgain[0] : '';

        if (this.tiktokUserID[0] !== '@') this.tiktokUserID = ('@' + this.tiktokUserID);
      }
    }
  }

  /**
   * Check point system configurations
   * Before this code was in settingscallback success, when ion view enter this code didn't firedup so moved to a function and call in ionViewDidEnter event too
   */
  async checkPointSystemConfigurations() {
    this.is_point_enable = false; // default
    this.is_point_recharge_enable = false; // default
    if (this.appService.appObject.settings.main_restaurant && this.appService.appObject.settings.main_restaurant.payment_methods) {
      const filteredArray = JSON.parse(this.appService.appObject.settings.main_restaurant.payment_methods).filter((item) => item.id === "points" && item.isActive === "true");
      if (filteredArray.length > 0) {
        this.is_point_enable = true;
        if (filteredArray[0].pointsConfigurations.points_recharge_enabled === 'true') {
          this.is_point_recharge_enable = true;
        } else {
          this.is_point_recharge_enable = false;
        }

        if (this.appService.appObject.isAuthed)
          await this.appService.getUserDetails({ customer_id: this.appService.appObject.userId });
        if (this.appService.appObject.isAuthed && this.appService.appObject.loggedInUserData && this.appService.appObject.loggedInUserData.points) {
          let pointsOb = this.appService.appObject.loggedInUserData.points.find((pointOb) => pointOb.restaurant_id === this.appService.appObject.settings.main_restaurant.id);
          if (pointsOb) {
            this.points = pointsOb.points;
          }
        }
      } else {
        this.is_point_enable = false;
      }
    }
  }

  ionViewDidEnter() {
    this.checkSocialMediaLinks();
    this.checkPointSystemConfigurations();
  }

  /**
   * Show how to change favourite restaurant guide popup open
   * @param ev event
   */
  async openTour(ev) {
    if (!this.appService.appObject.tourEnd) {
      const popover = await this.popoverCtrl.create({
        component: TourPage,
        cssClass: 'tour-class',
        event: ev,
        translucent: true,
        mode: 'ios',
        showBackdrop: false
      });
      await popover.present();
      this.appService.tourModeOn = true;

      this.appService.appObject.tourEnd = true;
      this.appService.updateAppObject();
    }
    // // to test uncomment below code
    // this.appService.appObject.tourEnd = false;
    // this.appService.updateAppObject();
  }

  ngDoCheck() {
    // order now button arrow colors get from theme object if available
    if (this.appService.appObject.theme && this.appService.appObject.theme.app && this.appService.appObject.theme.app.orderNowButtonArrowActiveColor && this.appService.appObject.theme.app.orderNowButtonArrowInactiveColor) {
      this.colorActive = this.appService.appObject.theme.app.orderNowButtonArrowActiveColor;
      this.colorInactive = this.appService.appObject.theme.app.orderNowButtonArrowInactiveColor;
    }

    if (this.appService.appObject.theme && this.appService.appObject.theme.app && this.appService.appObject.theme.app.favouriteRestaurantButtonBackground)
      this.favRestaurantIcon = this.appService.appObject.theme.app.favouriteRestaurantButtonBackground;
  }

  ionViewWillEnter() {
    this.fetchHighlightList();
    this.fetchBranchesList();
    if (!this.isFirst) {
      this.isCounter = false;
      this.appService.getSettings();
    }

    this.route.queryParams.subscribe((param) => {
      if (param.markedFavouriteRestaurant && param.markedFavouriteRestaurant === 'true') {
        if (!this.tourOpened) {
          this.tourOpened = true;
          setTimeout(() => {
            let ele = document.getElementById('enable-tour-click');
            if (ele) ele.click();
          }, 1000);
        }
      }

      // when return from the calculation function fail
      // get settings again to load home page data
      if (param.calculationFailed && param.calculationFailed === 'true') {
        this.appService.getSettings();
      }
    })
  }

  ionViewWillLeave() {
    if (this.isCounter) {
      this.subscription.unsubscribe();
    }
  }

  async openTableReservation() {
    const cartModal = await this.modalController.create({
      component: TableReservationPage,
      cssClass: 'custom-popup'
    });

    await cartModal.present();
  }

  /**
   * Fetch all branches
   */
  fetchBranchesList() {
    this.appService.appObject.restaurants = [];
    if (this.appService.isSettingsLoaded && this.appService.appObject.settings.app_configuration && this.appService.appObject.settings.app_configuration.show_branches) {
      this.appService.fetchAllRestaurants(true).then((response) => {
        // if (response === 'done') {
        //   console.log('restaurants : ', this.appService.appObject.restaurants);
        // }

        //console.log(this.appService?.appObject?.restaurants);
        //console.log('yai');

        const list = this.appService?.appObject?.ourBranches;
        const middleIndex = Math.ceil(list.length / 2);

        this.firstHalfs = list.slice().splice(0, middleIndex);
        this.secondHalfs = list.slice().splice(-middleIndex);

        // console.log(this.firstHalfs);  // [1, 2, 3]
        // console.log(this.secondHalfs); // [4, 5, 6]
        // console.log(list);

        // this.customContainer.style.height = '';

      }).catch((error) => {
        console.log('error : ', error);
      })
    } else {
      // this.customContainer.style.height = '';
    }
  }

  /**
   * Fetch highlighted product list
   */
  fetchHighlightList() {
    if (this.appService.isSettingsLoaded && this.appService.appObject.settings.app_configuration && this.appService.appObject.settings.app_configuration.show_highlights) {
      this.appService.appObject.isLoading = true;
      // fetch favourite restaurant action list when franchise mode is on and has selected favourite restaurant
      this.appService.fetchHighlightProducts((this.appService.appObject.settings.is_franchise === 'true' && this.appService.appObject.favouriteRestaurant) ? this.appService.appObject.favouriteRestaurant.id : null).then((response: any) => {
        // console.log('response : ', response);
        if (response.status) {
          this.mostPopularDishes = response.data;
        }
        this.appService.appObject.isLoading = false;
      }).catch((error) => {
        this.appService.appObject.isLoading = false;
      })
    }
  }

  /**
   * Will navigate into the ordering page of the selected branch
   * @param branch Selected branch to navigate into
   */
  navigateToBranch(branch) {
    if (branch && branch.slug) {
      this.orderNow(branch);
      // this.router.navigate(['restaurant', branch.slug]);
    }
  }

  getTimeDifference(date) {
    this.dDay = new Date(date);
    if (this.dDay < new Date()) {
      this.subscription.unsubscribe();
      this.isCounter = false;
      //this.appService.getSettings();
      return false;
    }
    this.timeDifference = this.dDay.getTime() - new Date().getTime();
    this.allocateTimeUnits(this.timeDifference);
  }

  allocateTimeUnits(timeDifference) {
    this.secondsToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond) % this.SecondsInAMinute);
    this.minutesToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour) % this.SecondsInAMinute);
    this.hoursToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour * this.SecondsInAMinute) % this.hoursInADay);
    this.daysToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour * this.SecondsInAMinute * this.hoursInADay));
  }

  call(number) {
    // console.log('Number to dial : ', number);
    // removes all white spaces from mobile number string  
    if (number) {
      number = (number + '').replace(/\s/g, '');
    }

    if (number)
      this.callNumber.callNumber(number, true)
        .then(res => console.log('Launched dialer!', res))
        .catch(err => console.log('Error launching dialer', err));
  }

  async orderNow(selectedBranch = null, showAll: boolean = false) {
    let componentProps = {
      'currentUI': 'order-type'
    }

    !selectedBranch ? componentProps['just_select_address'] = false : componentProps['selected_branch'] = selectedBranch;
    // show all restaurants
    showAll ? componentProps['showAll'] = true : '';

    const cartModal = await this.modalController.create({
      component: SelectOrderTypePage,
      cssClass: 'custom-popup',
      componentProps: componentProps
    });

    await cartModal.present();
  }

  /**
   * Has Multiple restaurants are off
   */
  async orderNowSingleRestaurant() {
    let componentProps = {
      'currentUI': 'select-postalcode',
      'triggerHandlePostalCodeFetch': true,
      'openPostalCodeRequestFormOnInit': this.logingWhileRequestingNewPostalCode,
    }

    // set select address ui if postal code mode is off
    if(this.appService.appObject.settings.is_postalcode !== 'true'){
      componentProps.currentUI = 'delivery-address'
    }

    if (this.appService.appObject.settings.main_restaurant) {
      // get avilable ordering methods
      let availableOrderingMethods = this.appService.findSelectedRestaurantOrderTypesV2(this.appService.appObject.settings.main_restaurant, true);
      // check if delivery is available (delivery method is prioratized by Pumayk26 for this BFF version)
      let isDeliveryAvailable = availableOrderingMethods.deliveryMethods.find((method) => method === 'delivery');
      if (availableOrderingMethods.deliveryMethods.length === 1 && isDeliveryAvailable) {
        this.appService.appObject.selectedDeliveryMethod = 'delivery';
        componentProps['hide_back_button'] = true;
      } else if (availableOrderingMethods.deliveryMethods.length) {
        // if delivery is not available, then check for any method and select first method
        this.appService.appObject.selectedDeliveryMethod = availableOrderingMethods.deliveryMethods[0];
        componentProps.currentUI = 'order-type';
      } else {
        // if there is no any ordering method available just show a message
        this.appService.showToast('Unable To Find a Ordering Method', 'danger');
        return;
      }

      this.appService.updateAppObject();

      const postalCodeSelect = await this.modalController.create({
        component: SelectOrderTypePage,
        cssClass: 'custom-popup',
        componentProps: componentProps
      });

      await postalCodeSelect.present();
    }
  }

  getDiscounts() {
    if (this.appService.appObject && this.appService.appObject.settings && this.appService.appObject.settings.main_restaurant) {
      let restaurant = this.appService.appObject.settings.main_restaurant;
      let options = [];
      if (restaurant.dinein_discount) {
        options.push({ value: restaurant.dinein_discount, label: 'key.discount_for_dinein' })
      }
      if (restaurant.pickup_discount) {
        options.push({ value: restaurant.pickup_discount, label: 'key.discount_for_pickup' })
      }
      if (restaurant.deliver_discount) {
        options.push({ value: restaurant.deliver_discount, label: 'key.discount_for_delivery' })
      }
      if (options.length) {
        let largestDiscount = this.largest(options);
        if (largestDiscount.value === restaurant.deliver_discount) {
          return [{ value: restaurant.deliver_discount, label: 'key.discount_for_delivery' }]
        } else {
          if (largestDiscount.value === restaurant.pickup_discount) {
            return [{ value: restaurant.pickup_discount, label: 'key.discount_for_pickup' }]
          }
          return [largestDiscount];
        }
      } else {
        return [];
      }
    }
    return [];
  }

  largest(arr) {
    let i;

    // Initialize maximum element
    let max = arr[0].value;
    let ob = arr[0];

    // Traverse array elements 
    // from second and compare
    // every element with current max 
    for (i = 1; i < arr.length; i++) {
      if (arr[i].value > max) {
        max = arr[i].value;
        ob = arr[i];
      }

    }
    return ob;
  }

  // /**
  //  * Open selected favourite restaurant delivery type select popup
  //  */
  //  async openFavouritePopup() {
  //   // const modal = await this.modalController.create({
  //   //   component: ModalPopoverPage,
  //   //   cssClass: 'order-popup',
  //   //   componentProps: {
  //   //     'title': 'key.select_order_type',
  //   //     'type': 'delivery-type',
  //   //     'fromFavouriteIcon': true
  //   //   }
  //   // });

  //   let componentProps = {
  //     'currentUI': 'redirect-to_favourite',
  //     'fromFavouriteIcon': true
  //   }
  //   const cartModal = await this.modalController.create({
  //     component: SelectOrderTypePage,
  //     cssClass: 'custom-popup',
  //     componentProps: componentProps
  //   });
  //   await cartModal.present();
  // }

  /**
   * open change select favourite restaurant popup 
   */
  async openChangeFavouriteRestaurant() {
    this.appService.appObject.favouriteRestaurant = null;
    this.appService.updateAppObject();

    let componentProps = {
      'currentUI': 'order-type',
      'selectFavouriteRestaurant': true
    }

    const cartModal = await this.modalController.create({
      component: SelectOrderTypePage,
      cssClass: 'custom-popup',
      componentProps: componentProps
    });

    await cartModal.present();
  }

  /**
   * User will navigate to the social media page
   * @param link social link to navigate 
   */
  public goToSocialLink(link) {
    if (link) {
      const options: InAppBrowserOptions = {
        location: 'yes',
        closebuttoncaption: 'Close'
      };
      let inab = this.inab.create(link);
    }
  }

  async openWelcomePackagePopUp() {
    // user can stop showing this offer, if do not show enabled, then won't trigger popup
    if (this.appService.appObject.doNotShowWelcomePackage) {
      return;
    }

    // if welcome package offer popup not opened, then pop it up
    if (!this.appService.welcomePackagePopupOpened) {
      let welcomeOrderPackage = this.appService.appObject.settings.main_restaurant.welcome_package_configurations;

      const welcomePopup = await this.modalController.create({
        component: WelcomePackageOfferPage,
        cssClass: 'custom-popup welcome-package-offer',
        componentProps: {
          package: { ...welcomeOrderPackage }
        }
      });

      this.appService.welcomePackagePopupOpened = true;

      await welcomePopup.present();

      let response = await welcomePopup.onDidDismiss()

      // console.log('response : ',);
      if (response && response.data && response.data.addToCart) {
        this.appService.welcomePackageOnTheWay = true;
        this.orderNow();
      } else {
        this.appService.welcomePackagePopupOpened = false;
      }
    }
  }

  /**
 * Open payments modal popup
 */
  async openPaymentModal() {
    const modal = await this.modalController.create({
      component: InputSelectModalPointsComponent,
      cssClass: 'select-modal',
      componentProps: {
        selectedRestaurant: this.appService.appObject.settings.main_restaurant
      },
    });
    // hide cart button when popup opening
    this.appService.hideCartButton = true;

    modal.present();
    // console.log(modal);
    modal.onWillDismiss().then(async (event) => {
      // this.getPointHistory();
      if (event.data.transaction_status === 'success') {
        this.successPayment = event.data;

        const modal = await this.modalController.create({
          component: InputSelectModalComponent,
          cssClass: 'select-modal',
          componentProps: {
            content: this.rechargeSuccess
          },
        });
        // hide cart button when popup opening
        this.appService.hideCartButton = true;

        modal.present();

        // refresh settings when user close payment success popup
        modal.onDidDismiss().then((res) => {
          this.appService.getSettings();
        })
      }
    });
  }

}
